// extracted by mini-css-extract-plugin
export default {"chart":"ProductSales_chart__OzWQ1"};